<template>
  <div class="menu">
    <div class="menu__header">
      <div class="container heading">
        <slot name="heading" />
      </div>
    </div>
    <div class="content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Menu",
  props: {
    heading: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  background: $color-white;

  .header {
    flex: 0 0 auto;
  }

  &__content {
    flex: 0 1 100%;
    padding-top: 10px;
    overflow-x: scroll;
  }

  .content {
    padding: 20px 0 30px;

    @include respond-above(md) {
      padding: 40px 0 30px;
    }
  }

  &__bottom {
    flex: 0 0 auto;
    background-color: $color-light;
    border-top: 1px solid rgba($color-dark, 0.2);
    display: flex;
    padding: 0 10px;
    justify-content: space-evenly;
  }

  &__button {
    padding: 17px 0;
    flex: 0 0 auto;
    background: none;
    outline: none;
    border: none;
    font-size: 10px;
    opacity: 0.2;
    text-decoration: none;

    &.router-link-active {
      opacity: 1;
    }
  }

  &__header {
    flex: 0 0 auto;
    background: $color-light;
    padding-top: 16px;
    padding-bottom: 16px;

    .heading {
      font-size: 16px;
      text-transform: uppercase;
      font-family: $heading-font-family;
    }
  }
}
</style>
